import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import config from "../config";

const AuthorizationContext = createContext();

export const AuthorizationProvider = ({ children }) => {
  const [permissions, setPermissions] = useState(null);
  const [dmtScope, setDMTScope] = useState(null);
  const [btScope, setBTScope] = useState(null);
  // const [mtScope, setMTScope] = useState(null);
  const [roles, setRoles] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPermissions = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("No token found");
        setLoading(false);
        return;
      }

      try {
        // 1. Fetch standard permissions (no change)
        const permissionsResponse = await axios.post(
          `${config.backendHost}auth/permissions`,
          {
            access_token: token,
          }
        );
        setPermissions(permissionsResponse.data.permissions);

        const dataMasteringPermission = permissionsResponse.data.permissions?.find(
          (perm) => perm.rsname === "DataMasteringTag"
        );
        setDMTScope(dataMasteringPermission?.scopes || null);

        const businessTaggingPermission = permissionsResponse.data.permissions?.find(
          (perm) => perm.rsname === "BusinessTag"
        );
        setBTScope(businessTaggingPermission?.scopes || null);

        // const myTaggingPermissions = permissionsResponse.data.permissions?.find(
        //   (perm) => perm.rsname === "MyTag"
        // );
        // setMTScope(myTaggingPermissions?.scopes || null);

        setRoles(permissionsResponse.data.roles);

        // 2. Fetch file type permissions (NEW)
      } catch (err) {
        setError("Failed to fetch permissions");
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, []);
  return (
    <AuthorizationContext.Provider value={{ btScope, dmtScope, permissions, roles, loading, error,}}>
      {children}
    </AuthorizationContext.Provider>
  );
};

export const useAuthorization = () => {
  const context = useContext(AuthorizationContext);
  if (context === undefined) {
    throw new Error("useAuthorization must be used within an AuthorizationProvider");
  }
  return context;
};
